<template>
    <v-container v-if="linkedContent">
        <v-card>
            <v-card-title>
                <div class="card-title-content">
                    <typo name="title-17-bold">{{ linkedContent.title }}</typo>
                    <linked-content-tools />
                </div>
            </v-card-title>
            <v-card-text>
                <linked-content-dialog-body
                    mode="page"
                    :body="linkedContent.body"
                ></linked-content-dialog-body>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import Vue from "vue";
import { Services } from "src/services/Services";
import LinkedContentTools from "./LinkedContentTools.vue";
import LinkedContentDialogBody from "./LinkedContentDialogBody.vue";

export default Vue.extend({
    components: {
        LinkedContentDialogBody,
        LinkedContentTools,
    },
    data() {
        return {
            linkedContent: null,
        };
    },
    async mounted() {
        this.linkedContent = await Services.api.linkedContent.get(this.$route.params.id);
    },
});
</script>

<style lang="sass" scoped>
.v-card__text
    padding: $grid-gutter*2 !important
    margin: auto

.v-card__title
    background: $color-background
    word-break: break-word

.card-title-content
    display: flex
    align-items: flex-start
    justify-content: space-between
    flex-grow: 1
@media print
    .container
        margin-right: 10mm
        margin-left: 10mm
        padding: 0
        width: auto

    .v-card
        box-shadow: none !important

    .v-card__title
        margin: 5mm 0 2.5mm
        padding: 5mm 0
        color: #381A01
        background: transparent
        font-size: 20pt
        font-weight: 300
        letter-spacing: 0.01em
        line-height: 1

    .v-card__text
        padding: 0 !important
</style>
